export function getHash() {
  return Math.round(Math.random() * 10000000000000)
}
